export const SET_MUNICIPIOS = "MUNICIPIOS/SET_MUNICIPIOS";
export const SET_MUNICIPIO = "MUNICIPIOS/SET_MUNICIPIO";
export const SET_ESTADOS = "MUNICIPIOS/SET_ESTADOS";
export const SET_ESTADO = "MUNICIPIOS/SET_ESTADO";
export const SET_PAGINATION = "MUNICIPIOS/SET_PAGINATION";
